<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'CLINIC.LBL_TITLE' | translate}}
              </h5>
            </div>
            <!-- Exit button -->
            <!-- <div class="col-sm-2">
              <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
                <i class="fas fa-sign-out"></i> Exit
              </button>
            </div> -->
          </div>
          <hr class="mt-0 mb-3" />
        </div>
        <div class="pt-3">
          <div class="container border rounded p-3 bold">
            <form [formGroup]="iSForm">
              <div class="form-group row">
                <div class="col-sm-4">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addnewclinic()"> <i class="far fa-plus"></i> Add New Clinic</button>
                </div>
              </div>
              <div class="form-group row">
                  <label for="Name" class="col-sm-2 col-form-label">Clinic Name</label>
                  <div class="col-sm-4">
                    <input type="text" class="form-control bold" id="name"   autocomplete="off"
                    formControlName="name" [(ngModel)]="name" (keyup)="searchBtnClickEvent()"/> 
                  </div>
                  <div class="col-sm-5">
                    <div class="form-row">
                      <!-- <div class="form-group col-md-0">
                        <button type="button" class="btn btn-primary btn-sm" (click)="searchBtnClickEvent()"> <i class="far fa-search"></i> Search</button>
                      </div> -->
                      <div class="form-group col-md-0">
                        <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
                      </div>
                    </div>
                  </div>
             </div>
            </form>
          </div>
		  </div>
		<div class="pt-3">
			<div class="container border rounded p-3 bold">
				<div id="grid-wrapper" class="col-sm-12 px-0" style="width: 100%; overflow: hidden;">
					<div class="col-sm-12 px-0" >
					  <ag-grid-angular style="width: 100%; height: 500px; " class="ag-theme-balham bold"
						[columnDefs]="columnDefs" (gridReady)="onGridReady($event)" [rowData]="rowData"
            (gridSizeChanged)="gridSizeChanged($event)" [defaultColDef]="defaultColDef"
            [animateRows]="true" [isExternalFilterPresent]="isExternalFilterPresent"
            [doesExternalFilterPass]="doesExternalFilterPass"
						[headerHeight]="60" [gridOptions]="gridOptions" >
					  </ag-grid-angular>
					</div>
				</div>
			</div>
		  </div>
      </div>
    </div>

    <ng-template #add_edit_Clinic>
      <div class="modal-md">
        <div class="modal-header">
            <h5 class="modal-title" [hidden]="updateMode">Add New Clinic</h5>
            <h5 class="modal-title" [hidden]="!updateMode">Edit Clinic</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelModal()">
              <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
        <div class="container-fluid bold">
              <div>
                <div class="container border rounded p-3 bold">
                    <form [formGroup]="iSForm">
                      <div class="form-group row">
                        <label for="clinicname" class="col-sm-4 col-form-label">Clinic Name</label>
                        <div class="col-sm-8"> 
                           <input type="text" class="form-control bold" id="clinicname" autocomplete="off"
                           [(ngModel)]="clinicname" formControlName="clinicname" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultclinicphone" class="col-sm-4 col-form-label">Phone</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control bold" id="defaultclinicphone" autocomplete="off"
                          [(ngModel)]="defaultclinicphone" formControlName="defaultclinicphone" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultclinicfax" class="col-sm-4 col-form-label">Clinic Fax</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultclinicfax" autocomplete="off"
                            [(ngModel)]="defaultclinicfax" formControlName="defaultclinicfax" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultstreetaddress1" class="col-sm-4 col-form-label">Street Address 1</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultstreetaddress1" autocomplete="off"
                            [(ngModel)]="defaultstreetaddress1" formControlName="defaultstreetaddress1" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultstreetaddress2" class="col-sm-4 col-form-label">Street Address 2</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultstreetaddress2" autocomplete="off"
                            [(ngModel)]="defaultstreetaddress2" formControlName="defaultstreetaddress2" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultcity" class="col-sm-4 col-form-label">City</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultcity" autocomplete="off"
                            [(ngModel)]="defaultcity" formControlName="defaultcity" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultstate" class="col-sm-4 col-form-label">State</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultstate" autocomplete="off"
                            [(ngModel)]="defaultstate" formControlName="defaultstate" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="defaultzipcode" class="col-sm-4 col-form-label">ZipCode</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="defaultzipcode" autocomplete="off"
                            [(ngModel)]="defaultzipcode" formControlName="defaultzipcode" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="clinicwebsite" class="col-sm-4 col-form-label">Clinic Website</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="clinicwebsite" autocomplete="off"
                            [(ngModel)]="clinicwebsite" formControlName="clinicwebsite" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="clinicemail" class="col-sm-4 col-form-label">Clinic Email</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="clinicemail" autocomplete="off"
                            [(ngModel)]="clinicemail" formControlName="clinicemail" (keypress)="changeValue()"/> 
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="cliniclogo" class="col-sm-4 col-form-label">Clinic Logo</label>
                        <div class="col-sm-8">
                          <input type="file" class="form-control bold" id="cliniclogo" autocomplete="off"
                          (change)="handleFileInput($event)" value="cliniclogo" accept=".jpg, .png"/>  
                        </div>
                      </div>
                      <div class="form-group row" [hidden] = "!image">
                        <div class="col-sm-4">
                        </div>
                        <div class="col-sm-4">
                          <div class="container border rounded p-3 bold">
						                <button type="button" class="close" (click)="deleteLogo()">
                              <span aria-hidden="true">×</span>
                            </button>
							              <img [src]="logoimage" style="width:inherit; height: inherit;align-content: center;">    
                          </div>
                        </div>
                      </div>
                      <!-- <div class="form-group row">
                        <label for="country" class="col-sm-4 col-form-label">Country</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="country" autocomplete="off"
                            [(ngModel)]="country" formControlName="country"/> 
                        </div>
                      </div> -->
                    </form>
                  </div>
              </div>
              <div id="grid-wrapper" class="col-sm-12 px-0" style="width: 100%; overflow: hidden;" [hidden]= "hideLocationGrid">
                <div class="col-sm-12 px-0" >
                  <ag-grid-angular style="width: 100%; height: 200px; " class="ag-theme-balham bold"
                  [columnDefs]="columnDefsLocation" (gridReady)="onGridReadyLocation($event)" [rowData]="rowDataLocation"
                  (gridSizeChanged)="gridSizeChanged($event)" [defaultColDef]="defaultColDefLocation"
                  [animateRows]="true" [headerHeight]="60" [gridOptions]="gridOptionsLocation" 
                  [animateRows]="true" [isExternalFilterPresent]="isExternalLocationFilterPresent"
                  [doesExternalFilterPass]="doesExternalLocationFilterPass">
                  </ag-grid-angular>
                </div>
              </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="form-group col-md-0">
            <button type="button" class="btn btn-primary btn-sm" (click)="addClinicLocation()"> <i class="fas fa-map-marker-alt"></i> Add Location</button>
          </div>
            <div class="form-group col-md-0">
              <button type="button" class="btn btn-primary btn-sm" (click)="saveClinicDetails()"> <i class="far fa-save"></i> Save</button>
            </div>
            <div class="form-group col-md-0">
              <button type="button" class="btn btn-primary btn-sm" (click)="cancelModal()"> <i class="far fa-times"></i> Cancel</button>
            </div>
        </div>
      </div>
      </ng-template>

      <ng-template #add_edit_Clinic_location>
        <div class="modal-md">
          <div class="modal-header">
              <h5 class="modal-title" [hidden]="locationupdateMode">Add Clinic Location</h5>
              <h5 class="modal-title" [hidden]="!locationupdateMode">Edit Clinic Location</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelModalLocation()">
                <span aria-hidden="true">×</span>
              </button>
          </div>
          <div class="modal-body">
          <div class="container-fluid bold">
                <div>
                  <div class="container border rounded p-3 bold">
                      <form [formGroup]="iSForm">
                        <div class="form-group row">
                          <label for="locationname" class="col-sm-4 col-form-label">Location Name</label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="locationname" autocomplete="off"
                            [(ngModel)]="locationname" formControlName="locationname"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="clinicphone" class="col-sm-4 col-form-label">Phone</label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control bold" id="clinicphone" autocomplete="off"
                            [(ngModel)]="clinicphone" formControlName="clinicphone"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="clinicfax" class="col-sm-4 col-form-label">Clinic Fax</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="clinicfax" autocomplete="off"
                              [(ngModel)]="clinicfax" formControlName="clinicfax"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="streetaddress1" class="col-sm-4 col-form-label">Street Address 1</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="streetaddress1" autocomplete="off"
                              [(ngModel)]="streetaddress1" formControlName="streetaddress1"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="streetaddress2" class="col-sm-4 col-form-label">Street Address 2</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="streetaddress2" autocomplete="off"
                              [(ngModel)]="streetaddress2" formControlName="streetaddress2"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="city" class="col-sm-4 col-form-label">City</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="city" autocomplete="off"
                              [(ngModel)]="city" formControlName="city"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="state" class="col-sm-4 col-form-label">State</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="state" autocomplete="off"
                              [(ngModel)]="state" formControlName="state"/> 
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="zipcode" class="col-sm-4 col-form-label">ZipCode</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="zipcode" autocomplete="off"
                              [(ngModel)]="zipcode" formControlName="zipcode"/> 
                          </div>
                        </div>
                        <!-- <div class="form-group row">
                          <label for="country" class="col-sm-4 col-form-label">Country</label>
                          <div class="col-sm-8">
                              <input type="text" class="form-control bold" id="country" autocomplete="off"
                              [(ngModel)]="country" formControlName="country"/> 
                          </div>
                        </div> -->
  
                      </form>
                    </div>
                </div>
            </div>
          </div>
          <div class="modal-footer">
              <div class="form-group col-md-0" [hidden] = "locationupdateMode">
                <button type="button" class="btn btn-primary btn-sm" (click)="saveLocationDetails()"> <i class="far fa-plus"></i> Add</button>
              </div>
              <div class="form-group col-md-0" [hidden] = "!locationupdateMode">
                <button type="button" class="btn btn-primary btn-sm" (click)="saveLocationDetails()"> <i class="far fa-edit"></i> Update</button>
              </div>
              <div class="form-group col-md-0">
                <button type="button" class="btn btn-primary btn-sm" (click)="cancelModalLocation()"> <i class="far fa-times"></i> Cancel</button>
              </div>
          </div>
        </div>
        </ng-template>